"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../");
var LoginPageForm = function (_a) {
    var loadErrors = _a.loadErrors;
    var _b = formik_1.useFormikContext(), isSubmitting = _b.isSubmitting, errors = _b.errors, setErrors = _b.setErrors;
    react_1.useEffect(function () { return setErrors(loadErrors); }, [loadErrors]);
    return (react_1.default.createElement(__1.Form, { "data-dusk": "login-form" },
        react_1.default.createElement(__1.Card, null,
            react_1.default.createElement("div", { className: "mb-4" },
                react_1.default.createElement(__1.FormHeading, { label: "Login" })),
            react_1.default.createElement(__1.FormControl, { errors: errors.email || [], label: "Email" },
                react_1.default.createElement(__1.Input, { placeholder: "Email", type: __1.InputType.email, name: "email" })),
            react_1.default.createElement(__1.FormControl, { label: "Password" },
                react_1.default.createElement(__1.Input, { placeholder: "Password", type: __1.InputType.password, name: "password" })),
            react_1.default.createElement(__1.Button, { className: "w-full", dusk: "login-btn", type: __1.ButtonType.submit, processing: isSubmitting }, "Login"))));
};
var LoginPage = function (_a) {
    var _b = _a.errors, errors = _b === void 0 ? {} : _b, onSubmit = _a.onSubmit;
    return (react_1.default.createElement(__1.AuthLayout, { dusk: "login-page" },
        react_1.default.createElement(__1.FormProvider, { initialValues: { password: '', email: '' }, onSubmit: onSubmit, validateOnChange: false, validateOnBlur: false },
            react_1.default.createElement(LoginPageForm, { loadErrors: errors }))));
};
exports.default = LoginPage;
//# sourceMappingURL=index.js.map